export const DISCORD_USER_ID = "f390cabc-a22a-11e9-98e6-c733443350ed";
